<template>
  <div ref="whole_page">
    <ul style="margin-top: 10px;flex-wrap: wrap;">
      <div class="limit-width_fixed-scalable" style="text-align: left;">
        <li>
          <vx-card class="glow-effect_bg-color__blend card__no-padding bg-color" style="width: 277px">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text glow-effect_bg-color__blend bg-color">
                  <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
                </div>
              </template>

              <vs-button
                        :disabled="true"
                        size="large"
                        class="button__fully-opaque button-text__left-align glow-effect_bg-color__blend header_button-lookalike text__school-tertiary-color bg-color"
                        type="filled"
                        color="">
                Select a Classroom
              </vs-button>
            </vx-input-group>
          </vx-card>
        </li>
      </div>

      <li v-for="(_classroom, index) in classrooms" :key="index" class="mb-4">
        <vx-card class="glow-effect_dark limit-width_fixed-scalable card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text input-group_prepend-slot-bg" style="border-radius: 5px 0 0 5px !important;">
                <span><feather-icon class="pt-1" icon="CodesandboxIcon" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
                       class="w-full button__fully-opaque button-text__left-align glow-effect_primary school-primary_gradient"
                       style="border-radius:0 7px 7px 0;"
                       @click="selectClassroom(_classroom)">
              {{ _classroom.name }}
            </vs-button>           
          </vx-input-group>
        </vx-card>       
      </li>

    </ul>
  </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
  components: {
    vSelect
  },
  data() {
    return {
      classrooms: []
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    getClassrooms() {
      var self = this;
      self.showLoadingOnElement("whole_page", 1, "material");
      var onSuccess = response => {
        self.classrooms = response.data;
      };
      var onFinally = function(response) {
        self.$vs.loading.close(self.$refs.whole_page.$el);
      };

      self.$ajaxGet(self, "Company/GetStudentClassrooms", onSuccess, onFinally);
    },
    selectClassroom(_classroom) {
      var self = this;
      self.$router.push({
        name: "StudentClassroomSelected",
        query: { id: _classroom.id }
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    self.getClassrooms();
  }
};
</script>
<style lang="scss">
  #categorydropdown {
    .vs__actions {
      display: contents !important;

      .open-indicator {
        margin-right: 10px !important;
      }
    }
  }
</style>
